export const defaultSorted = [{ dataField: "id", order: "asc" }];

export const sizePerPageList = [{ text: "50", value: 50 }];
export const initialFilter = {
  filter: { transactionDate: "today" },
  sortOrder: "", // asc||desc
  sortField: "",
  pageNumber: 1,
  pageSize: 50
};

export const initialFilterChart = {
  filter: { transactionDate: "thismonth" }
};
